module.exports = __webpack_public_path__ + "static/media/Hospitalslide3.add3cca0.webp";